import {
	createDataDirectsClient,
	type DataDirectsClient,
	createPrefixLookupClient,
	createPlaceLookupClient,
} from '@datadirects/datadirects-platform'

import { fetchHotelAutocomplete } from './AutocompleteClient'

const baseUrl = process.env.NEXT_PUBLIC_BACKEND_URL ?? ''
const clientRedirectEndpoint = baseUrl ? `${baseUrl}/hotels/client-redirect` : undefined
const trackingEndpoint = baseUrl ? `${baseUrl}/hotels/hotels-redirect` : undefined
const kayakRedirectEndpoint = '/api/kayak-redirect'

const prefixLookupClient = createPrefixLookupClient({
	baseUrl,
})

const placeLookupClient = createPlaceLookupClient({
	baseUrl,
})

/**
 * Shared DataDirects client instance for SHP.
 */
export const datadirectsClient: DataDirectsClient = createDataDirectsClient({
	site: 'searchhotelprices',
	defaultPartner: 'k',
	search: async ({ query, locale, signal }) => {
		const rows = await fetchHotelAutocomplete(query, locale ?? 'en-US', signal)
		return {
			places: rows.map((item) => {
				const placeType = item.type ?? 'city'
				return {
					id: item.placeId || item.documentId || item.destcode || query,
					name: item.name,
					type: placeType,
					entityId: item.placeId,
					iataCode: item.iata,
					primaryPlaceType: item.kayakType === 'ap' ? 'airport' : placeType,
					fullName: [item.name, item.city, item.country].filter(Boolean).join(', '),
					cityName: item.city,
					countryName: item.country,
					destcode: item.destcode,
					cityId: item.cityID,
					hotelId: item.type === 'hotel' ? item.placeId : undefined,
				}
			}),
		}
	},
	prefixLookup: async (destcode, locale) => {
		const result = await prefixLookupClient.lookupByDestcode({ destcode, locale })
		if (result === null && locale !== 'en') {
			return prefixLookupClient.lookupByDestcode({ destcode, locale: 'en' })
		}
		return result
	},
	placeLookup: (placeId, locale) => placeLookupClient.lookupByPlaceId({ placeId, locale }),
	redirect: {
		clientRedirectEndpoint,
		trackingEndpoint,
		kayakRedirectEndpoint,
	},
})
